<div class="row g-0" style="border-bottom: 1px solid #CDCED5;">
  <div class="col-12">
    <div class="filter-title">
      <div class="title">
        <a href="javascript:void(0)" class="filter-text-color">Filter</a> <a href="javascript:void(0)"
          class="ms-auto view-more d-none d-lg-block" (click)="clearAllFilter('Clear');clearFi()">Clear all</a>
        <a href="javascript:void(0)" class="ms-auto view-more d-lg-none" (click)="closeFilter()">Close</a>
      </div>
    </div>
  </div>
</div>
<div class="row  g-0">
  <div class="col-12">
    <div class="accordion" id="accordionFilter">
      <div class="accordion-item" *ngFor="let item of final_filter; let id=index">
        <h2 class="accordion-header" id="header{{id}}">
          <a style="text-decoration: none;" class="accordion-button collapsed"
            [ngClass]="{'active' : item.displayName == checkDisplayname }" data-bs-toggle="collapse" aria-expanded="false"
            data-bs-target="#collapseFilter{{id}}" href="#collapseFilter{{id}}" aria-controls="collapseFilter{{id}}">
            {{item.displayName}} <span class="ms-auto d-lg-none">
              {{item.displayName == 'Wheels' ? item?.data?.length : ''}}
              <ng-container *ngIf="item.displayName == 'Usage'">{{usageCount}}</ng-container>
              <ng-container *ngIf="item.displayName == 'Segment'">{{segmentCount}}</ng-container>
              <ng-container *ngIf="item.displayName == 'Main Vehicle Category'">{{mainVehicleCount}}</ng-container>
              <ng-container *ngIf="item.displayName == 'Model'">{{modelCount}}</ng-container>
              <ng-container
                *ngIf="item.displayName == 'Tonnage (Gross Vehicle Weight) & Wheels'">{{tonnageCount}}</ng-container>
              <ng-container *ngIf="item.displayName == 'Fuel Type'">{{fuelCount}}</ng-container>
              <ng-container *ngIf="item.displayName == 'Air Conditioning'">{{acCount}}</ng-container>
              <ng-container *ngIf="item.displayName == 'Body'">{{bodyCount}}</ng-container>
              <ng-container *ngIf="item.displayName == 'Load Body Length'">{{loadBodyCount}}</ng-container>
              <ng-container *ngIf="item.displayName == 'Cabin Type'">{{cabinTypeCount}}</ng-container>
              <ng-container *ngIf="item.displayName == 'Wheels'">{{wheelCount}}</ng-container>
              <ng-container *ngIf="item.displayName == 'Tonnage (Gross Vehicle Weight)'">{{tonnageCount}}</ng-container>
              <ng-container *ngIf="item.displayName == 'wheelbase'">{{wheelbasecount}}</ng-container>

            </span>
          </a>
        </h2>
        <div id="collapseFilter{{id}}" class="accordion-collapse collapse" [ngClass]="{'show' : item.displayName == checkDisplayname }"
          aria-labelledby="header{{id}}" data-bs-parent="#accordionFilter">
          <div class="accordion-body">
            <div class="search-p-scroll mb-2" *ngIf="item.displayName != 'Budget'">
              <input type="search" placeholder="Search {{item.displayName}}" #id id="{{id}}"
                class="form-control form-control-sm search-control" (input)="searchFilter(item,id.value)">
            </div>
            <div class="search-p-scroll mb-2" *ngIf="item.displayName == 'Budget'">
              <div class="highchart-wrapper">
                <div class="ngx-slider-wrapper">
                  <ngx-slider [(value)]="minValue" [(highValue)]="maxValue" [options]="ssoptions"
                    (mouseup)="sliderEvent()"></ngx-slider>
                  <div class="row mt-1">
                    <div class="col-6">
                      <label class="filter-label">Min Price</label>
                      <input type="text" [value]="minValue" class="form-control form-control-sm" maxlength="10"
                        minlength="1" (focusout)="onbudegetChange($event,'price_from')"
                        (keypress)="onlyNumberKey($event)" />
                    </div>
                    <div class="col-6">
                      <label class="filter-label">Max Price</label>
                      <input type="text" [value]="maxValue" class="form-control form-control-sm" maxlength="10"
                        minlength="1" (focusout)="onbudegetChange($event,'price_to')"
                        (keypress)="onlyNumberKey($event)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ltr-filter-scroll ps-1" *ngIf="item.displayName != 'Budget'">
              <div class="form-check" *ngFor="let row of getArray(item.values); let i=index">
                <input class="form-check-input" type="checkbox" value="" (click)="onCheckedClick(row.value,item.facetName,item.displayName)"
                  [checked]="row.checked">
                <label class="form-check-label" for="flexCheckChecked"  (click)="onCheckedClick(row.value,item.facetName,item.displayName)">
                  {{row.value}}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sticky-filter d-flex gap-3 d-lg-none">
      <a href="javascript:void(0)" class="btn btn-outline-primary btn-grad-outline-primary btn-brand text-uppercase"
        (click)="clearAllFilter('Mobile');clearFi()">Clear Filters</a>
      <a href="javascript:void(0)" class="btn btn-primary btn-grad-primary btn-brand text-uppercase"
        (click)="closeFilter()">Show {{searchTotal}} results</a>
    </div>
  </div>
</div>
